import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  PublicClientApplication,
} from '@azure/msal-browser';

const clientId = 'b5aced39-6d20-4c10-ab8c-03d808730202';

export const environment = {
  production: false,
  localDevJwt: null as string | null,
  // baseUrl: 'https://apim-dev-hilbertec.azure-api.net/dev/',
  searchUrl: 'https://apim-dev-hilbertec.azure-api.net/search/api/',
  reservationUrl: 'https://apim-dev-hilbertec.azure-api.net/reservation/api/',
  agencyUrl: 'https://apim-dev-hilbertec.azure-api.net/agency/api/',
  userUrl: 'https://apim-dev-hilbertec.azure-api.net/user/api/',

  notifyUrl: 'https://apim-dev-hilbertec.azure-api.net/',
  utilUrl: 'https://apim-dev-hilbertec.azure-api.net/utils/',

  //////////////////////////////////////////////////////////////////////////////////////

  authority:
    'https://b2bdevhilbertech.b2clogin.com/b2bdevhilbertech.onmicrosoft.com/B2C_1_SignIn',
  redirectUri: 'https://dev.flight-fusion.com',
  postLogoutRedirectUri: 'https://dev.flight-fusion.com',
  knownAuthorities: ['b2bdevhilbertech.b2clogin.com'],
  scope: `https://b2bdevhilbertech.onmicrosoft.com/${clientId}/api.access`,
};

export function MSALInstanceFactory() {
  return new PublicClientApplication({
    auth: {
      clientId: clientId,
      authority: environment.authority,
      redirectUri: environment.redirectUri,
      postLogoutRedirectUri: undefined,
      knownAuthorities: environment.knownAuthorities,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false,
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap: new Map([
      ['https://b2bdevhilbertech.b2clogin.com', ['api.access']],
    ]),
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Popup,
    authRequest: {
      scopes: ['openid', 'offline_access', 'api.access'],
    },
  };
}
